export default 'https://raw.githubusercontent.com/ucscXena/cohortMetaData/master';
